import React, { useState } from 'react';
import Header from './Header';
import Sidebar from './Sidebar';

const Layout = ({ children, onLogout }) => {
  const [sidebarOpen, setSidebarOpen] = useState(true);
  const toggleSidebar = () => setSidebarOpen((o) => !o);
  
  return (
    <div className="app-layout">
      <div className="app-body">
        {sidebarOpen && <Sidebar onToggleSidebar={toggleSidebar} onLogout={onLogout} />}
        <div className={`content-wrapper ${sidebarOpen ? '' : 'sidebar-closed'}`}>
          <Header sidebarOpen={sidebarOpen} onToggleSidebar={toggleSidebar} onLogout={onLogout} />
          <main className={`main-content ${sidebarOpen ? '' : 'expanded'}`}>
            {children}
          </main>
        </div>
      </div>
    </div>
  );
};

export default Layout;
